//testnet
export const foil_swap_address =
  "0xd4ca773cec7b3abdca54c778b3a27602dfe11ba11c69d9f520a8f3e07eb11390";
export const foil_vesting_address =
  "0x1a0334910ad16ca8603a91b6be1429854a5d12e943075363cd6ccf0c7d00b75f";
export const foil_util_address =
  "0x9707302f214f593cfd235084558e111fff49fdfde3897fa9cd506ce14887a2be";

export const swap_address =
  "0x4a1ed03e1e2b8cfb805fa60fa89b7ac4f9b8a27240084cd6d0d06dd2b0f89c3e";
export const farm_address =
  "0x5a6dd00665f1334ff3979ef0e5d5f16bf7562ccf60cff94e132462cb221956a7";
export const test_coin_address =
  "0xdaa23b70b58c85aa0b6696cc163dd88c35a9afc703369a056a829d0bac623242";
